export default __webpack_public_path__ + "static/republiquefrancaise-3d87683e3d28cecea0bda742aa1df7ac.svg";